import React from 'react';
import { Eye, Truck, RotateCcw, MapPin } from 'lucide-react';
import InvoiceLangMenu from './InvoiceLangMenu';
import { ORDER_STATUSES, getStatusColor } from './OrderDetailDrawer';
import { ordersAPI } from '../services/api';
import QuickContact from './QuickContact';

const OrderCard = ({ order, onOpen, onStatusChange }) => {
  const count = order.items?.reduce((n, i) => n + i.quantity, 0) || 0;
  return (
    <article data-testid={`order-card-${order.id}`} className="bg-white rounded-lg shadow-sm p-4 space-y-3">
      <button type="button" onClick={() => onOpen(order.id)} className="w-full text-left space-y-2" data-testid={`order-card-open-${order.id}`}>
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="text-sm font-semibold text-blue-600">{order.order_number || `${order.id.slice(0, 8)}…`}</p>
            <p className="text-xs text-gray-500">{new Date(order.created_at).toLocaleDateString('fr-FR')}</p>
          </div>
          <p className="text-base font-bold text-gray-900 shrink-0">{order.total.toFixed(2)} €</p>
        </div>
        <div className="flex flex-wrap items-center gap-1.5">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(order.status)}`}>{order.status}</span>
          {order.payment_status === 'pending' && <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800" data-testid={`order-card-awaiting-payment-${order.id}`}>Paiement en attente</span>}
        </div>
        <div className="text-sm text-gray-800">
          <p className="font-medium truncate">{order.customer_name}</p>
          {order.shipping_info && <p className="text-xs text-gray-500 flex items-center gap-1"><MapPin size={11} /> {order.shipping_info.postalCode} {order.shipping_info.city}</p>}
        </div>
        <p className="text-xs text-gray-500 line-clamp-2">{count} article(s) · {order.items?.map((i) => (i.pack_label ? `${i.name} (${i.pack_label})` : i.name)).join(', ')}</p>
        {order.restocked && <p className="text-[11px] text-green-700 flex items-center gap-1" data-testid={`order-card-restocked-${order.id}`}><RotateCcw size={11} /> Stock restitué{order.cancelled_by === 'customer' ? ' (client)' : ''}</p>}
        {order.tracking_number && <p className="text-[11px] text-gray-400 flex items-center gap-1" data-testid={`order-card-tracking-${order.id}`}><Truck size={11} /> {order.tracking_carrier} {order.tracking_number}</p>}
      </button>
      <QuickContact phone={order.shipping_info?.phone} email={order.shipping_info?.email} testId={`order-card-${order.id}`} />
      <div className="flex items-center gap-2 pt-2 border-t">
        <select
          data-testid={`order-card-status-select-${order.id}`}
          value={order.status}
          onChange={(e) => onStatusChange(order.id, e.target.value)}
          className="flex-1 min-w-0 text-sm border rounded-md px-2 py-2 bg-white"
        >
          {ORDER_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <button data-testid={`order-card-view-${order.id}`} onClick={() => onOpen(order.id)} title="Voir le détail" className="p-2 text-blue-600 hover:bg-blue-50 rounded-md border"><Eye size={18} /></button>
        <InvoiceLangMenu order={order} variant="icon" label="Télécharger la facture" onDownload={(lang) => ordersAPI.downloadInvoice(order, lang)} />
      </div>
    </article>
  );
};

const AdminOrderCards = ({ orders, onOpen, onStatusChange }) => (
  <div className="space-y-3" data-testid="orders-cards">
    {orders.map((o) => <OrderCard key={o.id} order={o} onOpen={onOpen} onStatusChange={onStatusChange} />)}
  </div>
);

export default AdminOrderCards;
